/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mining-factory': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M62.188 5H57.3v4.566h4.888V5zm0 20.627V11.883H57.3v13.744h-1.812v9.771h-2.807v-9.771h-1.805V11.883h-4.89v13.744h-1.814v9.771H37.9v18.644h-3.4V13.7H0v44.804h64V25.627h-1.812zm-38.21-6.23h5.136v5.136h-5.137v-5.136zm0 9.296h5.136v5.134h-5.137v-5.134zm0 9.295h5.136v5.138h-5.137v-5.138zM14.68 19.397h5.135v5.136h-5.135v-5.136zm0 9.296h5.135v5.134h-5.135v-5.134zm0 9.295h5.135v5.138h-5.135v-5.138zM5.387 19.397h5.133v5.136H5.387v-5.136zm0 9.296h5.133v5.134H5.387v-5.134zm0 9.295h5.133v5.138H5.387v-5.138zM45.987 5h4.888v4.566h-4.889V5z" _fill="#EF7812"/>'
  }
})
